//********* NAVIGATION *********//
import * as types from "./actionTypes";
import {setTrumbleInventoryForFeatures} from "../api/look-api";
import {ROUTES} from "../routes";
import {getCurrentIntroSteps, LOOK_OVERLAYS} from "../bvcomponents/look/core/constants";
import {toggleShowAssignQuotePopup} from "./assignPopupFunctions";

export const setLookOpened = (lookOpened = false) => {
  return (dispatch, getState) => {
    const store = getState();
    const {isMobile} = store.serverState;
    const {shopPageOpened} = store.shopState;

    dispatch({
      type: types.SET_LOOK_OPENED,
      payload: {lookOpened, isMobile, shopPageOpened}
    });
  }
};

export const setLookExpanded = (lookExpanded = false) => ({
  type: types.SET_LOOK_OPENED,
  payload: {lookExpanded}
});

export const setLookParentKeys = (lookParentKeys = []) => ({
  type: types.SET_LOOK_PARENT_KEYS,
  payload: {lookParentKeys}
});

export const setLookViewType = (lookViewType = 1) => ({
  type: types.SET_LOOK_VIEW_TYPE,
  payload: {lookViewType}
});

export const setWishlistPopupOpened = (wishlistPopupOpened = false) => ({
  type: types.SET_WISHLIST_POPUP_OPENED,
  payload: {wishlistPopupOpened}
});

export const setSidebarModalOpened = (sidebarModalOpened = false) => ({
  type: types.SET_SIDEBAR_MODAL_OPENED,
  payload: {sidebarModalOpened}
});

export const setLookActiveFeature = (newLookActiveFeature = null, lookActiveFeaturePositionInList = null) => {
  return (dispatch, getState) => {
    const store = getState();
    const {isMobile} = store.serverState;
    dispatch({
      type: types.SET_LOOK_ACTIVE_FEATURE,
      payload: {lookActiveFeature: newLookActiveFeature, lookActiveFeaturePositionInList, isMobile}
    });

    const {settings} = store.fabricatorState;
    if (newLookActiveFeature && settings.useTrumbleApi && !newLookActiveFeature.quantityOptions) {
      setTrumbleInventoryForFeatures([newLookActiveFeature]).then(() => {
        dispatch({
          type: types.UPDATE_LOOK_ACTIVE_FEATURE_STOCK_COUNT,
        });
      })
    }
  }
};

export const setLookActiveCategory = (lookActiveCategory = "") => {
  return (dispatch, getState) => {
    const store = getState();
    const {isMobile} = store.serverState;
    dispatch({
      type: types.SET_LOOK_ACTIVE_CATEGORY,
      payload: {lookActiveCategory, isMobile}
    });
  }
};

export const setLookMoreInfoOpened = (moreInfoOpened = "", moreInfoContent = "") => ({
  type: types.SET_LOOK_MORE_INFO_OPENED,
  payload: {moreInfoOpened, moreInfoContent}
});

export const setLookPageOpened = (lookPageOpened) => {
  return (dispatch, getState) => {
    const store = getState();
    const {isMobile} = store.serverState;
    if (isMobile) {
      if (lookPageOpened === ROUTES.cart) {
        document.body.style.overflow = "hidden";
      } else if (!lookPageOpened && store.lookState.lookPageOpened === ROUTES.cart) {
        document.body.style.overflow = "";
      }
    }
    dispatch({
      type: types.SET_LOOK_PAGE_OPENED,
      payload: {lookPageOpened, isMobile}
    });
  }
};

export const setLookOverlayOpened = (lookOverlayOpened, lookOverlayAction = "") => {
  return (dispatch) => {
    if (lookOverlayOpened === LOOK_OVERLAYS.leadCapture && document.kvConfig.isBackend) {
      // const buttons = lookOverlayAction !== "aiLeadCapture" ? "save" : null;
      const buttons = "save"; // only save on the look journey, no contracts, no checkout, no nothing.
      dispatch(toggleShowAssignQuotePopup(true, buttons))
    }
    dispatch({
      type: types.SET_LOOK_OVERLAY_OPENED,
      payload: {lookOverlayOpened, lookOverlayAction}
    });
  }
};

export const setLookViewChangeOptions = (lookViewChangeOptions) => ({
  type: types.SET_LOOK_VIEW_CHANGE_OPTIONS,
  payload: {lookViewChangeOptions}
});

export const setLookStylePopup = (lookStylePopup) => ({
  type: types.SET_LOOK_STYLE_POPUP,
  payload: {lookStylePopup}
});

export const setLookRemovePopup = (lookRemovePopup) => ({
  type: types.SET_LOOK_REMOVE_POPUP,
  payload: {lookRemovePopup}
});

export const setLookIntroStep = (introStep) => {
  return (dispatch, getState) => {
    if (!introStep) {
      const {serverState, lookState} = getState();
      const steps = getCurrentIntroSteps(serverState.isMobile);
      const stepIndex = steps.findIndex(step => step === lookState.introStep);
      introStep = steps[stepIndex + 1];
    }
    dispatch({
      type: types.SET_LOOK_INTRO_STEP,
      payload: {introStep}
    })
  }
}

export const setLookIntroHidden = (introHidden) => ({
  type: types.SET_LOOK_INTRO_HIDDEN,
  payload: {introHidden}
});

export const setLookContextMenu = (contextMenu) => ({
  type: types.SET_LOOK_CONTEXT_MENU,
  payload: {contextMenu}
});

export const setLookWallsApplyTo = (lookWallsApplyTo) => ({
  type: types.SET_LOOK_WALLS_APPLY_TO,
  payload: {lookWallsApplyTo}
});

export const setLookAllWallsOpened = (lookAllWallsOpened) => ({
  type: types.SET_LOOK_ALL_WALLS_OPENED,
  payload: {lookAllWallsOpened}
});

export const setLookReturnAction = (lookReturnAction) => ({
  type: types.SET_LOOK_RETURN_ACTION,
  payload: {lookReturnAction}
});

export const setLookDemoPointsClicked = (lookDemoPointsClicked) => ({
  type: types.SET_LOOK_DEMO_POINTS_CLICKED,
  payload: {lookDemoPointsClicked}
});

export const updateNavigationCount = () => ({
  type: types.UPDATE_LOOK_NAVIGATION_COUNT,
});

export const updateFeatureGroupCount = () => ({
  type: types.UPDATE_LOOK_FEATURE_GROUP_COUNT,
});

export const setLookCompatabilityAlert = (lookCompatabilityAlert) => ({
  type: types.SET_LOOK_COMPATABILITY_ALERT,
  payload: {lookCompatabilityAlert}
});

export const setLookRestoreState = (lookRestoreState) => ({
  type: types.SET_LOOK_RESTORE_STATE,
  payload: {lookRestoreState}
});

export const setLookLockedTutorial = (lookLockedTutorial) => ({
  type: types.SET_LOOK_LOCK_TUTORIAL,
  payload: {lookLockedTutorial}
});

export const setLookAllWallsTutorial = (lookAllWallsTutorial) => ({
  type: types.SET_LOOK_ALL_WALLS_TUTORIAL,
  payload: {lookAllWallsTutorial}
});
